import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import WhatsAppFloat from '../../components/WhatsAppFloat';
import HeroSection from './components/HeroSection';
import BrandStorySection from './components/BrandStorySection';
import TrustCredentialsSection from './components/TrustCredentialsSection';
import AwardsRecognitionSection from './components/AwardsRecognitionSection';
import CommunityImpactSection from './components/CommunityImpactSection';
import { SITE, WA_MESSAGES, openWhatsApp } from '../../config/site';

const AboutDynastyBrandHeritage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleWhatsAppClick = () => openWhatsApp(WA_MESSAGES.general);

  return (
    <>
      <Helmet>
        {/* Deindexed: keep site reachable directly, but out of search results. */}
        <meta name="robots" content="noindex, nofollow, noarchive, nosnippet, noimageindex" />
        <meta name="googlebot" content="noindex, nofollow, noarchive, nosnippet, noimageindex" />
        <title>Official Nitin Online Book | Nitin Online Book - India's Best Gaming Platform</title>
        <meta
          name="description"
          content="Discover the story of Nitin Online Book and Nitin Online Book, the official online gaming platform in India. Learn about our heritage, values, licences and commitment to secure, fair play. Find Nitin online book login, sign up and app download info here."
        />
        <meta
          name="keywords"
          content="Nitin Online Book, Nitin Online Book, Nitin book, Nitin betting book, Nitin online book login, Nitin online book sign up, Nitin online book app download, Nitin online book app, Nitin online book india, Nitin online book download, Nitin BOOK betting, Nitin online book review"
        />
        <meta property="og:title" content="About Nitin Online Book - Nitin Online Book | Premium Gaming Platform" />
        <meta
          property="og:description"
          content="Discover the story of Nitin Online Book and Nitin Online Book, India's leading online gaming platform — heritage, values and a commitment to secure, enjoyable gaming."
        />
        <meta property="og:image" content={`${SITE.url}/assets/images/gen/about-banner.svg`} />
        <meta property="og:url" content={`${SITE.url}/about-dynasty-brand-heritage`} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={SITE.name} />
        <meta property="og:locale" content="en_IN" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Nitin Online Book - Nitin Online Book | Premium Gaming Platform" />
        <meta
          name="twitter:description"
          content="The heritage, licences and player-first values behind Nitin Online Book and Nitin Online Book."
        />
        <meta name="twitter:image" content={`${SITE.url}/assets/images/gen/about-banner.svg`} />
        <link rel="canonical" href={`${SITE.url}/about-dynasty-brand-heritage`} />

        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE.url}/` },
              { '@type': 'ListItem', position: 2, name: 'About', item: `${SITE.url}/about-dynasty-brand-heritage` },
            ],
          })}
        </script>
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        <main>
          <HeroSection onWhatsAppClick={handleWhatsAppClick} />
          <BrandStorySection />
          <TrustCredentialsSection />
          <AwardsRecognitionSection />
          <CommunityImpactSection onWhatsAppClick={handleWhatsAppClick} />
        </main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </>
  );
};

export default AboutDynastyBrandHeritage;
